import { render, staticRenderFns } from "./ErrorDisplay.vue?vue&type=template&id=15cff7e6"
import script from "./ErrorDisplay.vue?vue&type=script&lang=ts"
export * from "./ErrorDisplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports